import React, { useState, useEffect, useRef } from "react";
import styles from "./ProRealtorAI.module.css";

const ProServiceChat = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      // Add user message
      setMessages([
        ...messages,
        {
          text: input,
          type: "user",
          timestamp: new Date().toLocaleTimeString(),
        },
      ]);
      setInput("");

      // Simulate receiving a response
      setTimeout(() => {
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            text: input,
            type: "user",
            timestamp: new Date().toLocaleTimeString(),
          },
          {
            text: "Thank you for reaching out! How can we assist you with your real estate needs today?",
            type: "service",
            timestamp: new Date().toLocaleTimeString(),
          },
        ]);
      }, 1000);
    }
  };

  useEffect(() => {
    // Scroll to the bottom when a new message is added
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className={styles.proServiceChat}>
      <div className={styles.chatWindow}>
        <div className={styles.messages}>
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`${styles.message} ${styles[msg.type]}`}
            >
              <div className={styles.avatar}></div>
              <div className={styles.messageContent}>
                <div className={styles.messageText}>{msg.text}</div>
                <div className={styles.timestamp}>{msg.timestamp}</div>
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
        <form className={styles.inputForm} onSubmit={handleSubmit}>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message here..."
            className={styles.input}
          />
          <button type="submit" className={styles.sendButton}>
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProServiceChat;
